var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"register_content",class:{'showLoginPannel':_vm.$store.state.isShowRegisterPanel && !_vm.$store.state.isLogin}},[_c('member-register-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }